export const thaloColors = {
  // Primary Blues
  primary: {
    deepNavy: "#000F89",
    brightBlue: "#01A4FE",
    green: "#28C877",
    pinkRed: "#D81B60",
    mediumBlue: "#007DC2",
    skyBlue: "#52C1FE",
    lightBlue: "#B2E3FF",
    softLavender: "#DDE1F8",
    deepCyan: "#0C74C8",
    violet: "#4B0DA0",
  },
  
  // Secondary Blues
  secondary: {
    navyMuted: "#3D3F92",       // darker version of deep navy
    blueMuted: "#0173A1",       // toned-down bright blue
    greenMuted: "#209B67",      // softer green
    pinkMuted: "#B11750",       // muted pink/red
    steelBlue: "#4F82A5",       // darkened medium blue
  },

  // Accent Colors
  accent: {
    peach: "#FFA45C",
    apricot: "#FFB86B",
    coral: "#FF8F6B",
    softOrange: "#FFD38D",
    lightPeach: "#FFC4A3",
  },

  // Neutral Colors
  neutral: {
    black: '#1E293B', // Current thalo-black
    darkGrey: '#475569', // Current thalo-grey
    grey: '#94A3B8',
    lightGrey: '#E2E8F0',
    white: '#F8FAFC',
  },

  // Background Colors
  background: {
    DEFAULT: '#F1F5F9', // From custom-bg-gradient
    light: '#FCFBF8',
    dark: '#E2E8F0',
  },

  // Status Colors
  status: {
    green: "#3BBF6F",   // branded green
    yellow: "#FFD666",   // soft yellow
    red: "#F25C5C",     // warm red/pink
  },

  // UI Colors
  ui: {
    border: '#E2E8F0',
    input: '#F1F5F9',
    ring: '#94A3B8',
    hover: '#F8FAFC',
    active: '#E2E8F0',
  }
} as const;

// Type for the color palette
export type ThaloColor = keyof typeof thaloColors;
export type ThaloColorVariant = 'DEFAULT' | 'light' | 'lighter' | 'dark' | 'darker';

// Helper function to get a color
export function getThaloColor(color: ThaloColor, variant: ThaloColorVariant = 'DEFAULT'): string {
  const colorObj = thaloColors[color];
  if (typeof colorObj === 'string') return colorObj;
  return (colorObj as Record<string, string>)[variant] || (colorObj as Record<string, string>)['DEFAULT'];
}

// Example usage:
// getThaloColor('primary') // Returns '#000F89'
// getThaloColor('primary', 'light') // Returns '#0040A2'
// getThaloColor('accent', 'teal') // Returns '#00A4FE' 